import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import classnames from 'classnames';
import get from 'lodash.get';
import { PageLayout } from 'dibs-elements/exports/PageLayout';

import { HpRespModuleContainer } from '../HpRespModuleContainer/HpRespModuleContainer';
import { HpRespShopByModuleItem } from './HpRespShopByModuleItem';
import { trackShopByItemsImpressions, trackShopByItemClick } from '../helpers/shopByTracking';
import { ATTRS_L1_CREATOR, ATTRS_ATTRIBUTE } from './gaConstants';
import { SharedInViewport } from '../../sharedComponents/SharedInViewport';
import { TABLET_ITEMS_PER_PAGE } from '../constants';

import styles from './HpRespShopByModule.scss';

export const handleInitialDisplay = ({ inViewport, items }) => {
    if (items && inViewport) {
        trackShopByItemsImpressions(items);
    }
};

export const HpRespShopByModuleComponent = props => {
    const shopByModule = get(props, 'homepage.shopByModule');

    if (!shopByModule) {
        return null;
    }

    const { items = [], title } = shopByModule;

    return (
        <HpRespModuleContainer addTopGap>
            <PageLayout setViewportBackground={'sassyColorBuyerTertiary'}>
                <HpRespModuleContainer.Header title={title} />
                <SharedInViewport
                    stopWhenInViewport
                    onInViewportChange={({ inViewport }) =>
                        handleInitialDisplay({ inViewport, items })
                    }
                >
                    <div className={classnames('rowFlex', styles.shopByWrapper)}>
                        <div className="colXs12">
                            <div className={classnames('rowFlex', styles.itemsWrapper)}>
                                {items.map((item, index) => {
                                    const isTopRow = index < TABLET_ITEMS_PER_PAGE;

                                    return (
                                        <HpRespShopByModuleItem
                                            key={item.cmsId}
                                            item={item}
                                            isTopRow={isTopRow}
                                            className={
                                                isTopRow ? 'colXs6 colLg3' : 'colXs12 colMd4'
                                            }
                                            gaDataAttrs={
                                                isTopRow ? ATTRS_L1_CREATOR : ATTRS_ATTRIBUTE
                                            }
                                            onClick={() => trackShopByItemClick(item, index)}
                                        />
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </SharedInViewport>
            </PageLayout>
        </HpRespModuleContainer>
    );
};

HpRespShopByModuleComponent.propTypes = {
    homepage: PropTypes.object.isRequired,
};

export const HpRespShopByModule = createFragmentContainer(HpRespShopByModuleComponent, {
    homepage: graphql`
        fragment HpRespShopByModule_homepage on Homepage {
            shopByModule: module(type: "shopBy") {
                ... on ShopByModule {
                    title
                    items {
                        cmsId
                        title
                        linkData {
                            # shopByTracking.js
                            path
                            ...SeoLink_linkData
                        }
                        imageUrl
                    }
                }
            }
        }
    `,
});
